import * as React from "react";
import { AnimatePresence, motion } from "motion/react";
import { Label } from "./label";
import { cn } from "@/lib/utils";

/** Címke + mező + súgó/hiba egységes elrendezése. */
export function Field({
  label,
  htmlFor,
  error,
  hint,
  className,
  children,
  optional,
}: {
  label?: React.ReactNode;
  htmlFor?: string;
  error?: string;
  hint?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
  optional?: boolean;
}) {
  return (
    <div className={cn("min-w-0 space-y-1.5", className)}>
      {label && (
        <Label htmlFor={htmlFor} className="flex items-baseline gap-2">
          {label}
          {optional && <span className="text-xs font-normal text-muted-foreground">nem kötelező</span>}
        </Label>
      )}
      {children}
      <AnimatePresence initial={false} mode="wait">
        {error ? (
          <motion.p key="e" initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} className="text-sm font-medium text-destructive">
            {error}
          </motion.p>
        ) : hint ? (
          <p key="h" className="text-sm text-muted-foreground">
            {hint}
          </p>
        ) : null}
      </AnimatePresence>
    </div>
  );
}
